module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.itemForm,
      "items": _vm.itemForm
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitAddForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Add Log Filter")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23cd88bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-log-filter.vue
// module id = 539
// module chunks = 4 5 6